
export function formatAppointmentTooltipDate(theDate: string | Date, timeZone?: string): string {
    return new Date(theDate).toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        timeZone
    })
}